import moment from 'moment';
import { eventMomentFactory } from "../misc/eventMomentFactory";

export function isItemForDate(event, date, item) {
    if (!moment.isMoment(date)) date = eventMomentFactory(event, date);
    let start = eventMomentFactory(event, item.start_local);

    // console.log(date.format(), start.format());

    return date.isSame(start, 'day');
}
